
<template>
  <div class="collection-sorting border">
    <select-input v-if="$mq !== 'mobile' && $mq !== 'tablet'" :disableDefault="true" :options="sortingOptions" v-model="currentValue"></select-input>
    <div class="collection-sorting__mobile" v-else>
      <div class="collection-sorting__mobile-option" v-for="option in sortingOptions" :key="option.value" :class="isActvieSortMethod(option.value)" @click="mobileSortSelect(option.value)"><span class="body-md">{{option.label}}</span></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectInput from '@/scripts/components/forms/SelectInput.vue'

export default {
  name: 'CollectionSorting',
  components: { SelectInput },
  props: {
    defaultSort: String,
    mobileClickBinding: Function,
    value: String
  },
  data () {
    return {
      currentValue: this.value ? this.value : this.defaultSort,
      sortingOptions: [
        { label: 'Sort By: Featured', value: 'manual' },
        { label: 'Sort By: Most Popular', value: 'best-selling' },
        { label: 'Sort By: Newest Arrivals', value: 'created-descending' },
        { label: 'Sort By: Price: Low to High', value: 'price-ascending' },
        { label: 'Sort By: Price: High to Low', value: 'price-descending' },
        { label: 'Sort By: A-Z', value: 'title-ascending' },
        { label: 'Sort By: Z-A', value: 'title-descending' }
      ]
    }
  },
  methods: {
    mobileSortSelect (value) {
      this.currentValue = value
      if (this.mobileClickBinding) {
        this.mobileClickBinding()
      }
    },
    isActvieSortMethod (value) {
      if (this.currentValue === value) {
        return 'sort-active'
      }
    }
  },
  watch: {
    value() {
      this.currentValue = this.value;
    },
    currentValue() {
      this.$store.dispatch('collections/updateSort', this.currentValue)
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style scoped lang="scss">
  .collection-sorting {
    width: 235px;
    min-width: 200px;
    @include desktop-up {
      max-width: 304px;
    }
    &__mobile {
      &-option {
        padding: 16px;
        border-bottom: 1px solid $color-light-grey;
        cursor: pointer;
        &.sort-active {
          color: $color-black;
        }
      }
    }

    /deep/ .input--select {
      margin: .5rem 0;
    }
  }

  .sort-mobile-menu {
    .collection-sorting__mobile-option {
      border: none;
      position: relative;
      padding: 13px 24px;
      &:last-child {
        margin-bottom: 27px;
      }
      &:before {
        width: 16px;
        height: 16px;
        display: block;
        content: "";
        border: 1px solid #979391;
        border-radius: 16px;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        position: absolute;
      }
      &:hover {
        &:before {
          border-color: $color-black-900;
        }
      }

      &.sort-active {
        &:before {
          border: 4px solid $color-black-900;
        }
      }
    }
  }
</style>
